import {showModalType} from 'stores/actions/typedModalAction';
import {showErrorMissingTrayModal, showModalInvalidDeck} from 'stores/business/modalStateBusinessAction';
import {setupWizardMissingTrayAction} from 'stores/business/setupWizardBusiness/setupWizardInstrumentBusiness';
import {setErrorCodeNumber} from 'stores/business/commonBusiness';
import {hideLoading} from 'stores/actions/appStateAction';
import {setIsTrayAttached} from 'stores/actions/trayCalibrationStateAction';
import {manualReteachMissingTrayHandler} from 'stores/business/errorHandlers/manualReteachErrorHandler';
import {FastRobotErrorcode, MissingTrayOngoingProcess, ModalType, ViewMode} from '../../../constants/dataEnum';
import {clearModalError, hideModal, setModalValid} from '../../../stores/actions/modalStateAction';
import {ejectTray} from '../../../stores/business/instrumentBusiness';
import {checkAndHandleTraySuitability} from '../../../stores/business/trayCheckingBusiness';
import {showMissingTrayModal, showMissingTrayPutLabwareInTrayModal} from '../../../stores/business/trayModalBusiness';

export const getMissingTrayOngoingProcess = () => (dispatch, getState) => {
  const {viewMode} = getState().appState;

  switch (viewMode) {
    case ViewMode.TRAY_CALIBRATION:
      return MissingTrayOngoingProcess.TRAY_CALIBRATION;
    case ViewMode.PLATE_TYPE_EDITOR:
      return MissingTrayOngoingProcess.PLATE_TYPE_EDITOR;
    case ViewMode.SETUP_WIZARD:
      return MissingTrayOngoingProcess.SETUP_WIZARD;
    default:
      return MissingTrayOngoingProcess.GENERAL;
  }
};

export const handlePostMissingTrayScanTrayId = () => async (dispatch, getState) => {
  const {typedModalState} = getState();
  const {permissionChecker, successCallback, failedCallback} = typedModalState.data || {};

  dispatch(hideLoading());

  const isSuitable = await dispatch(checkAndHandleTraySuitability(failedCallback, permissionChecker));

  if (isSuitable) {
    dispatch(hideModal());

    if (permissionChecker.isDoingPlateDefinition()) {
      dispatch(clearModalError());

      await dispatch(ejectTray());
      dispatch(showMissingTrayPutLabwareInTrayModal(successCallback));
      return;
    }

    successCallback();
  }
};

export const onTrayDetached = () => async (dispatch, getState) => {
  const {appState, typedModalState} = getState();
  const {viewMode, isManualReteachPage, loading} = appState;

  dispatch(setIsTrayAttached(false));

  // Besides these views, there's no need for missing tray handling
  if (
    viewMode !== ViewMode.TRAY_CALIBRATION &&
    viewMode !== ViewMode.PLATE_TYPE_EDITOR &&
    viewMode !== ViewMode.SETUP_WIZARD
  ) {
    return;
  }

  await dispatch(setErrorCodeNumber(FastRobotErrorcode.MissingTray));
  dispatch(setModalValid());
  if (loading.show) dispatch(hideLoading());

  // the tray was being lifted in the midst of tray recovery
  if (typedModalState.isShown) {
    dispatch(showModalType(ModalType.MISSING_TRAY_ERROR, typedModalState.data));
  }

  // Setup wizard handling
  if (viewMode === ViewMode.SETUP_WIZARD) {
    dispatch(showMissingTrayModal(false, null, () => dispatch(setupWizardMissingTrayAction())));
    return;
  }

  // Manual reteach handling
  if (viewMode === ViewMode.PLATE_TYPE_EDITOR && isManualReteachPage) {
    const callback = () => dispatch(manualReteachMissingTrayHandler());

    dispatch(showErrorMissingTrayModal(callback));
    return;
  }

  // default missing tray modal
  dispatch(showModalInvalidDeck());
};
